module.exports = __webpack_public_path__ + "img/pr-2.9eb8c9f5.png";